import React from 'react'
import LightningFilledIcon from 'transfix-icons/build/LightningFilledIcon'
import { Button } from 'transfix-ui/components/Button'
import { makeStyles } from 'transfix-ui/core'
import { brandColors } from 'transfix-ui/theme'
import { useBreakpointContext } from 'utils/context/BreakpointContext'
import { SystemModal } from 'components/SystemModal'
import { useModalState } from 'utils/hooks'

const useApiLinkStyles = makeStyles(theme => ({
  root: {
    color: brandColors.skyBlue6,
    fontSize: '14px',
    height: 14,

    [theme.breakpoints.up('lg')]: {
      height: 'auto',
    },

    /**
     * When below md, remove padding alogether from button
     */
    [theme.breakpoints.down('xl')]: {
      padding: 0,
    },
  },
}))

const ApiLink = () => {
  const classes = useApiLinkStyles()
  const { isDesktop } = useBreakpointContext()

  const { createToggleHandler, modalState } = useModalState({
    systemModal: false,
  })

  const toggleSystemModalHandler = createToggleHandler('systemModal')

  const startIcon = isDesktop ? <LightningFilledIcon size='large' color='coolGray0' /> : undefined

  if (__ENV__ === 'production') {
    return null
  }

  return (
    <>
      <Button
        data-test='ApiLink'
        variant='text'
        size={isDesktop ? 'large' : 'small'}
        className={classes.root}
        onClick={toggleSystemModalHandler}
        startIcon={startIcon}>
        STAGING API
      </Button>
      {modalState.systemModal && <SystemModal open close={toggleSystemModalHandler} />}
    </>
  )
}

export default ApiLink
